// extracted by mini-css-extract-plugin
export default {"scrollbarTrack":"Scrollbar_scrollbarTrack__8swo+"};